import { render, staticRenderFns } from "./resumen-pagos.vue?vue&type=template&id=b7e11a14&"
import script from "./resumen-pagos.component.ts?vue&type=script&lang=ts&"
export * from "./resumen-pagos.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports